// eslint-disable-next-line
export { default as Typeahead } from './StyledTypeahead';
